<template>
	<div>
		<div v-if="images.length > 1" :class="thumbnailContainerClasses" class="relative thumbnail-outer-container">
			<div ref="thumbnail-container" class="thumbnail-container white-space-wrap hide-native-scrollbar">
				<div v-for="(image, i) in images" :key="image.key" class="thumbnail-item" @click="$refs['swiper'].swiperInstance.slideTo(i)" ref="thumbnail-items">
					<ding-image :src="image.imageUrl" aspect-ratio="1:1" mode="fill" />
				</div>
			</div>
			<div v-if="currentIndex > 0" class="thumbnail-arrow thumbnail-up-arrow" @click="goToPrev">
				<img src="/img/icon_arrow_up.png" />
			</div>
			<div v-if="currentIndex < images.length - 1" class="thumbnail-arrow thumbnail-down-arrow" @click="goToNext">
				<img src="/img/icon_arrow_down.png" />
			</div>
		</div>
		<div class="relative image-swiper-container">
			<div v-if="canGoPrev && !hideSwiperButton" class="swiper-button swiper-prev-button">
				<div class="inner" @click="goToPrev">
					<img class="forward-icon" src="/img/backward.png" />
				</div>
			</div>
			<swiper ref="swiper" :slides-per-view="3" :space-between="0" @slideChangeTransitionEnd="onSlideChange">
				<swiper-slide v-for="image in images" :key="image.key">
					<ding-image :src="image.imageUrl" width="100%" aspect-ratio="1:1" mode="fill" :zoomOnHover="true" />
				</swiper-slide>
			</swiper>
			<div v-if="canGoNext &&!hideSwiperButton" class="swiper-button swiper-next-button" @click="goToNext">
				<div class="inner">
					<img class="forward-icon" src="/img/forward.png" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment';
import DingImage from '../common/Image.vue';
import PhotoViewer from '../common/PhotoViewer.vue';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

export default {
	components: { DingImage, PhotoViewer, Swiper, SwiperSlide },
	props: {
		context: { required: true, type: Object },
		provider: { required: true, type: Object },
		images: { required: true, type: Array },
	},
	computed: {
		canGoNext() {
			return this.currentIndex < this.images.length - 1;
		},
		canGoPrev() {
			return this.currentIndex > 0;
		},
	},
	data() {
		const isMobile = window.innerWidth <= 480;

		return {
			hideSwiperButton: false,
			currentIndex: 0,
			thumbnailContainerClasses: {
				'has-content-upward': false,
				'has-content-downward': false
			},
			isMobile,
		};
	},
	mounted() {
		this.$nextTick(() => {
			const hasThumbnailWindow = (!this.isMobile && this.images.length > 1);
			const css = {
				width: hasThumbnailWindow ? '80%' : '100%'
			};
			if (hasThumbnailWindow) {
				$('.thumbnail-container, .thumbnail-outer-container').css({height: `${$('.image-swiper-container').height()}px`});
				this.$refs['thumbnail-container'].addEventListener('scroll', this.updateThumbnailContainerClasses);
				this.hideSwiperButton = true;
			} else {
				$('.thumbnail-container, .thumbnail-outer-container').remove();
				css.width = '100%';
				$('.image-swiper-container').css(css);
			}
			this.$refs.swiper.swiperInstance.update();
		});
	},
	beforeDestroy() {
		if (this.zoomOnHover) {
			this.$refs['thumbnail-container'].removeEventListener('scroll', this.updateThumbnailContainerClasses);
		}
	},
	watch: {
		currentIndex() {
			if (this.currentIndex) {
				this.$refs['thumbnail-items'][this.currentIndex].scrollIntoView(false);
			}
		}
	},
	methods: {
		goToNext() {
			this.$refs['swiper'].swiperInstance.slideNext(300);
		},
		goToPrev() {
			this.$refs['swiper'].swiperInstance.slidePrev(300);
		},
		updateThumbnailContainerClasses() {
			const $el = this.$refs['thumbnail-container'];
			this.thumbnailContainerClasses = {
				'has-content-upward': $el.scrollTop > 0,
				'has-content-downward': $el.scrollTop + $el.clientHeight < $el.scrollHeight
			}
		},
		onSlideChange() {
			this.currentIndex = this.$refs['swiper'].swiperInstance.activeIndex;
		},
	}
}
</script>

<style scoped lang="scss">
.swiper-prev-button {
	right: 56px;
}

.swiper-next-button {
	right: 0;
}

.swiper-button {
	padding: 12px;
	z-index: 10;
	position: absolute;
	bottom: 0px;
	cursor: pointer;
	display: flex;
	user-select: none;;

	&:hover {
		opacity: 0.75;
	}

	.inner {
		width: 44px;
		height: 44px;
		border-radius: 22px;
		background-color: #41414199;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 25px;
			height: 25px;
		}
	}
}

.thumbnail-outer-container {
	position: relative;
	width: 16%;
	display: block;
	float: left;
	overflow: hidden;
}

.thumbnail-container {
	overflow: auto;
	padding: 6px 0 36px;
	margin: 0px 6px 36px;
}

.thumbnail-item {
	cursor:pointer;
	&:hover {
		opacity: 0.75;
	}
	margin-bottom: 8px;
}

.image-swiper-container {
	width: 84%;
	float: left;
}

.thumbnail-arrow {
	background: #41414199;
	height: 30px;
	padding: 5px 0;
	width: 100%;
	cursor: pointer;
	&:hover {
		background: #000000aa;
	}
	text-align: center;

	&.thumbnail-up-arrow {
		position: absolute;
		top: 0;
		left: 0;
		img {
			margin-top: 4px;
		}
	}
	&.thumbnail-down-arrow {
		position: absolute;
		bottom: 0;
		left: 0;
		img {
			margin-bottom: 4px;
		}
	}

	img {
		height: 20px;
	}
}
</style>
